export const COUNT_ADS_PER_PAGE = 20;
export const CATALOG_ADS_PER_PAGE = 24;

export const COUNT_FRIENDS_PER_PAGE = 50;
export const SEPARATOR = ';;:;;';
